import { Switch } from 'components/ui/switch';
import React from 'react';

interface FeatureFlagRowProps {
  id: string;
  title: string;
  description: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const FeatureFlagRow: React.FC<FeatureFlagRowProps> = ({
  id,
  title,
  description,
  checked,
  disabled = false,
  onChange,
}) => {
  return (
    <div className="mb-3 mt-4">
      <div className="flex justify-between items-center">
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-blue-80 leading-5">
            {title}
          </h3>
          <p className="font-normal text-sm leading-5 text-gray-blue-70 mt-0.5">
            {description}
          </p>
        </div>
        <div className="ml-6 shrink-0">
          <Switch
            className="mt-1"
            id={id}
            checked={checked}
            disabled={disabled}
            onCheckedChange={onChange}
          />
        </div>
      </div>
    </div>
  );
};
